import React from "react";
import Reveal from "./Reveal";
import { floorPlans } from "../mock";

const FloorPlans = () => {
  return (
    <section className="bg-neg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col items-center">
            <h2 className="font-display text-neg-navy text-4xl sm:text-5xl text-center">
              {floorPlans.title}
            </h2>
            <span className="mt-5 h-px w-16 bg-neg-gold" />
          </div>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          {floorPlans.images.map((img, i) => (
            <Reveal key={i} delay={i * 120}>
              <div className="group bg-white p-4 shadow-lg shadow-black/10 overflow-hidden">
                <div className="overflow-hidden">
                  <img
                    src={img}
                    alt={`Floor plan ${i + 1}`}
                    className="w-full object-contain transition-transform duration-700 group-hover:scale-[1.03]"
                    loading="lazy"
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="mt-8 text-center text-neg-navy/50 italic text-sm">{floorPlans.note}</p>
      </div>
    </section>
  );
};

export default FloorPlans;
